import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DATE_PROPERTY_NAMES = new Set(['createdate',
// Deal + Ticket
'closedate',
// Deal
'closed_date' // Ticket
]);
const toAbsoluteUrl = val => {
  const raw = /^https?:\/\//i.test(val) ? val : `https://${val}`;
  try {
    const {
      protocol
    } = new URL(raw);
    return protocol === 'http:' || protocol === 'https:' ? raw : undefined;
  } catch (_unused) {
    return undefined;
  }
};
const renderProperty = prop => {
  if (!prop.value) {
    return null;
  }

  // Special case for "Create date" and "Close date"
  if (DATE_PROPERTY_NAMES.has(prop.name)) {
    return /*#__PURE__*/_jsx(Badge, {
      display: "inline-flex",
      use: "koala",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: prop.value
      })
    });
  }
  if (prop.name === 'domain') {
    const href = toAbsoluteUrl(prop.value);
    if (!href) return prop.value;
    return /*#__PURE__*/_jsx(Link, {
      href: href,
      target: "_blank",
      children: prop.value
    });
  }
  return prop.value;
};
export const CrmRecordChipCardContent = ({
  properties
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    gap: "400",
    paddingInline: "400",
    children: properties.map(prop => /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        marginBlockEnd: "100",
        children: prop.label
      }), renderProperty(prop)]
    }, prop.name))
  });
};